import { apiService } from "api/apiService";
import type {
  FilterResource,
  TeacherPortfolioTaskShallowResource,
} from "api/generated";
import { mapPaginatedResponse } from "api/mappers/pagination.mapper";
import type { PaginatedResponse, PaginatedResult } from "api/types";
import { teacherScheduledTaskFromDto } from "portfolio/api/mappers";
import type { TeacherScheduledTask } from "portfolio/types";
import { mapFilters } from "shared/mappers";
import type { Filter } from "shared/types";

export const fetchLessonClassTasks = async (
  scheduleId: string,
  params: Record<string, string> = {},
): Promise<PaginatedResult<TeacherScheduledTask>> => {
  const { data } = await apiService.get<
    PaginatedResponse<TeacherPortfolioTaskShallowResource>
  >(`api/my-lessongroups/${encodeURIComponent(scheduleId)}/portfolio-tasks`, {
    params,
  });

  return mapPaginatedResponse(data, teacherScheduledTaskFromDto);
};

export const fetchLessonClassTaskFilters = async (
  scheduleId: string,
): Promise<Filter[]> => {
  const {
    data: { data: filters },
  } = await apiService.get<{ data: FilterResource[] }>(
    `api/my-lessongroups/${encodeURIComponent(scheduleId)}/portfolio-tasks/filters`,
  );

  return mapFilters(filters);
};
